const ELEMENT = { CLASS_NAME: 'overlay-element', HANDLE: 'js-overlay-element' };
const SELECTED = { CLASS_NAME: 'is-highlighted' };
const TEXT_VISIBLE = { CLASS_NAME: 'is-text-visible' };
const LABEL = { CLASS_NAME: 'overlay-label' };
const BACKDROP = { CLASS_NAME: 'overlay-backdrop', HANDLE: 'js-backdrop' };
const UNSELECTABLE = { CLASS_NAME: 'is-unselectable' };
const ZOOMED_OUT = { CLASS_NAME: 'is-zoomed-out' };
const MATCH = { CLASS_NAME: 'is-match' };

const LABEL_FONT_SIZE = 16;

const TOOLTIP = {
  TEXT_VISIBLE: 'Klicken um text zu verstecken',
  NOT_TEXT_VISIBLE: 'Klicken um text anzuzeigen'
};

import { Rect } from 'openseadragon';

import EventEmitter from 'events';

function createHTMLOverlayLabel(parent, segments) {
  segments.map((s) => {
    let n;
    if (s.isMatch) {
      n = document.createElement('strong');
    }
    else {
      n = document.createElement('span');
    }
    n.textContent = s.string;
    return n;
  }).forEach(node => parent.appendChild(node));
}

function createHTMLOverlay({ id, content, highlight, segments }, toggleable = true) {
  const el = document.createElement('div');
  el.setAttribute('id', id);
  el.classList.add(ELEMENT.CLASS_NAME, ELEMENT.HANDLE);
  if (highlight) {
    el.classList.add(MATCH.CLASS_NAME);
  }

  const p = document.createElement('p');
  p.classList.add(LABEL.CLASS_NAME, UNSELECTABLE.CLASS_NAME);

  if (segments && segments.length > 0) {
    createHTMLOverlayLabel(p, segments);
  }
  else {
    p.textContent = content;
  }

  el.setAttribute('title', TOOLTIP.TEXT_VISIBLE);

  el.appendChild(p);

  return el;
}

function createHTMLBackdrop() {
  const el = document.createElement('div');
  el.classList.add(BACKDROP.CLASS_NAME, BACKDROP.HANDLE);
  return el;
}

function createOpenSeadragonOverlay(viewer, { rect: { x, y, width, height }, ...params }) {
  const htmlOverlay = createHTMLOverlay({ ...params });
  return {
    element: htmlOverlay,
    location: viewer.viewport.imageToViewportRectangle(x, y, width, height),
    onDraw(position, size, element) {
      Object.assign(element.style, {
	left: `${position.x}px`,
	top: `${position.y}px`,
	width: `${size.x}px`,
	height: `${size.y}px`
      });

      // FIXME: use width for resizing
      const ratio = Math.min(1, Math.floor(0.75 * 10 * size.y / LABEL_FONT_SIZE) / 10);

      element.children[0].style.transform = `scale(${ratio})`;
    }
  };
}

function createOverlayBackdrop(viewer) {
  return {
    element: createHTMLBackdrop(),
    location: new Rect(0, 0, 1, viewer.viewport.getAspectRatio()),
  };
}

function toggleVisibility() {
  const node = document.querySelector('.' + BACKDROP.HANDLE);
  toggleClassName(node, TEXT_VISIBLE.CLASS_NAME);
  Array.from(document.querySelectorAll('.' + ELEMENT.HANDLE)).forEach((node) => {
    if (!toggleClassName(node, TEXT_VISIBLE.CLASS_NAME)) {
      node.setAttribute('title', TOOLTIP.NOT_TEXT_VISIBLE);
    }
    else {
      node.setAttribute('title', TOOLTIP.TEXT_VISIBLE);
    }
  });
}

function setVisibility(value) {
  const nodes = [
    document.querySelector('.' + BACKDROP.HANDLE),
    ...Array.from(document.querySelectorAll('.' + ELEMENT.HANDLE))
  ];

  nodes.forEach((node) => value === true
		? node.classList.remove(TEXT_VISIBLE.CLASS_NAME)
		: node.classList.add(TEXT_VISIBLE.CLASS_NAME));
}

function setElementSelected(element, isSelected) {
  const className = SELECTED.CLASS_NAME;

  if (isSelected && !element.classList.contains(className)) {
    element.classList.add(className);
  }
  else if (!isSelected && element.classList.contains(className)) {
    element.classList.remove(className);
  }
}

function setElementClassName(element, className, isFlagSet) {
  if (isFlagSet && !element.classList.contains(className)) {
    element.classList.add(className);
  }
  else if (!isFlagSet && element.classList.contains(className)) {
    element.classList.remove(className);
  }
}

function toggleClassName(node, ...classNames) {
  if (node.classList.contains(...classNames)) {
    node.classList.remove(...classNames);
    return false;
  }
  else {
    node.classList.add(...classNames);
    return true;
  }
}

function setElementTooltipText(element, isTextVisible) {
  const tooltipText = isTextVisible
	? TOOLTIP.TEXT_VISIBLE
	: TOOLTIP.TEXT_VISIBLE;

  element.setAttribute('title', tooltipText);
}

export default function ({
  openSeadragon,
  elements,
  mode = 'toggleable',
  onOverlayClick
}) {
  const elementsById = {};

  openSeadragon.addOverlay(createOverlayBackdrop(openSeadragon));

  // NOTE: append elements to DOM in reverse order, so in case of
  //       overlapping elements, those with lower y top coords
  //       overlap those lower ones
  const reversedElements = elements.slice().reverse();
  reversedElements.forEach((item) => {
    const overlay = createOpenSeadragonOverlay(openSeadragon, item);
    elementsById[item.id] = overlay;

    if (typeof onOverlayClick === 'function') {
      overlay.element.addEventListener('click', () => onOverlayClick(item));
    }

    openSeadragon.addOverlay(overlay);
  });

  const matches = elements
	.filter((element) => element.isHighlighted)
	.map((element) => element.id);

  return {
    setVisibility,
    update(elements) {
      // this is the place where declarative vs. imperative paradigms clash, so this method is quite weird

      let elementToPanTo = null;
      elements.forEach((element) => {
	if ([true, false].includes(element.isTextVisible)) {
	  setElementClassName(
	    elementsById[element.id].element,
	    TEXT_VISIBLE.CLASS_NAME,
	    element.isTextVisible
	  );
	  setElementTooltipText(
	    elementsById[element.id].element,
	    element.isTextVisible
	  );
	}
	if ([true, false].includes(element.isSelected)) {
	  setElementClassName(
	    elementsById[element.id].element,
	    SELECTED.CLASS_NAME,
	    element.isSelected
	  );
	}
	if ([true, false].includes(element.isHighlighted)) {
	  setElementClassName(
	    elementsById[element.id].element,
	    MATCH.CLASS_NAME,
	    element.isHighlighted
	  );
	}
	if (true === element.isFocused && element.eventSource === 'content') {
	  elementToPanTo = elementsById[element.id];
	}
      });

      if (elementToPanTo !== null) {
	panTo(openSeadragon, elementToPanTo.location);
      }
    },
    destroy() {
      // remove event listeners, etc.
    }
  };
};

import { Point } from 'openseadragon';

function panTo(viewer, rect) {
  const isImmediate = false;

  const point = {
    x: rect.x + rect.width / 2,
    y: rect.y + rect.height / 2
  };

  viewer.viewport
    .panTo(new Point(point.x, point.y), isImmediate)
    .applyConstraints(isImmediate);
}
